import type { Appointments } from "@/lib/appointments"

import type { BookingSummaryProps } from "@/components/Booking/BookingSummary"
import { SummaryBlock } from "@/components/Booking/SummaryBlock"
import { Divider } from "@/components/common/Divider/Divider"

type PriceProps = {
  price_cents: Appointments.AppointmentDetails[`price_cents`] | undefined
  style: BookingSummaryProps[`style`]
}

export const Price = ({ price_cents, style }: PriceProps) => {
  return price_cents !== undefined ? (
    <SummaryBlock style={style} className={`py-0`}>
      <div className={`flex items-center justify-between font-semibold`}>
        <span className={`flex-grow py-4`}>Total</span>
        <Divider flexChild orientation={`vertical`} thickness={1} />
        <span className={`ml-4 py-4`}>
          {price_cents == 0 ? `Free` : `$${(price_cents / 100).toFixed(2)}`}
        </span>
      </div>
    </SummaryBlock>
  ) : null
}
